export default "__VITE_ASSET__t9SZTdr___"